import { Injectable } from '@angular/core';
import { CanDeactivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { EcomPaymentMethodsComponent } from './ecom-payment-methods.component';

@Injectable()
export class PaymentCanDeactivateGaurdService implements CanDeactivate<EcomPaymentMethodsComponent> {
    constructor(private router: Router) { }

    // canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    //     window.location.href = route.data['externalUrl'];
    //     return true;

    // }

    canDeactivate(component: EcomPaymentMethodsComponent): boolean {
        // if (component.clickEvent === 'BACK' && component.cardForm.dirty) {
        //     return confirm('Are you sure to cancel the payment?');
        // }
        // if (component.clickEvent === 'BACK') {
        //     return confirm('Are you sure to cancel the payment?');
        // }
        return true;
    }
}
